import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionAction, MedicationInfusionRedLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-red-label-slot',
    templateUrl: './medication-infusion-red-label-slot.component.html',
    styleUrl: './medication-infusion-red-label-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionRedLabelSlotComponent implements SheetSlotComponentBase {

	action!: MedicationInfusionRedLabelAction;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionAction | null) {
		this.action = action as MedicationInfusionRedLabelAction;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}